module.exports = __webpack_public_path__ + "static/media/p0204.8bf41ef1.png";